import BaseAPI from 'services/api/base.api';

import { Plugin } from 'interface/plugin/plugin.interface';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export default class PluginAPI extends (BaseAPI!) {
  private ROUTES = {
    all: '/context/ctxschema/contextplugins?limit=1000000',
    allHistorical: '/context/ctxhistory/query?limit=1000000',
    historical: 'context/ctxhistory/query',
    pluginById: '/context/ctxschema/contextplugins',
  };

  // whitelist flybits/sdk plugins only.
  getPlugins(): Promise<Plugin[]> {
    return this.GET(this.ROUTES.all);
    // Use the following method for whitelisting.
    // return this.GET(this.ROUTES.all).then((plugins: any) => plugins.filter((plugin: any) => ["flybits", "sdk"].includes(plugin.provider)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getHistoricalPlugins(id: string): Promise<any> {
    return this.GET(`${this.ROUTES.historical}/${id}?limit=1000000`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPluginById(id: string): Promise<any> {
    return this.GET(`${this.ROUTES.pluginById}/${id}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAllHistoricalPlugins(): Promise<any> {
    return this.GET(this.ROUTES.allHistorical);
  }
}
